import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProfileState } from '../reducers/profile.reducer';
import { PROFILE_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ProfileState>(PROFILE_FEATURE_KEY);

export const selectProfile = createSelector(selectState, (state: ProfileState) => state.profile);
export const selectLoaded = createSelector(selectState, (state: ProfileState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: ProfileState) => state.loading);
export const selectSaving = createSelector(selectState, (state: ProfileState) => state.saving);
export const selectSaved = createSelector(selectState, (state: ProfileState) => state.saved);
export const selectPasswordSaving = createSelector(selectState, (state: ProfileState) => state.passwordSaving);
export const selectPasswordSaved = createSelector(selectState, (state: ProfileState) => state.passwordSaved);
export const selectPasswordError = createSelector(selectState, (state: ProfileState) => state.passwordError);
